import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Loading from '../components/Loading/Loading';
import ProtectedRoute from '../components/Auth/ProtectedRoute';

const Home = lazy(() => import('../pages/HomePage/Home'));
const About = lazy(() => import('../pages/AboutPage/About'));
const Service = lazy(() => import('../pages/ServicePage/Service'));
const Proof = lazy(() => import('../pages/ProofPage/Proof'));
const Inquiry = lazy(() => import('../pages/InquiryPage/Inquiry'));
const Contact = lazy(() => import('../pages/ContactPage/Contact'));
const Privacy = lazy(() => import('../pages/PolicyPage/Privacy'));
const Error404 = lazy(() => import('../pages/ErrorPage/Error404'));

/* 채용공고 */
const RecruitList = lazy(() => import('../pages/RecruitPage/RecruitList'));
const RecruitDetail = lazy(() => import('../pages/RecruitPage/RecruitDetail'));
const RecruitForm = lazy(() => import('../pages/RecruitPage/RecruitForm'));

/* 관리자 */
const Login = lazy(() => import('../pages/LoginPage/Login'));

const Router = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />
          <Route path="/about/:tab" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/service/:tab" element={<Service />} />
          <Route path="/proof" element={<Proof />} />
          <Route path="/proof/:tab" element={<Proof />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* 채용공고 — 등록·수정은 관리자만 */}
          <Route path="/recruit" element={<RecruitList />} />
          <Route
            path="/recruit/upload"
            element={
              <ProtectedRoute>
                <RecruitForm />
              </ProtectedRoute>
            }
          />
          <Route path="/recruit/:id" element={<RecruitDetail />} />
          <Route
            path="/recruit/:id/edit"
            element={
              <ProtectedRoute>
                <RecruitForm />
              </ProtectedRoute>
            }
          />

          <Route path="/manager/login" element={<Login />} />

          {/* 구 경로 → 신 경로 리다이렉트 (색인·북마크 보존) */}
          <Route path="/biz" element={<Navigate to="/" replace />} />
          <Route path="/biz/about" element={<Navigate to="/about" replace />} />
          <Route path="/biz/about/:tab" element={<Navigate to="/about" replace />} />
          <Route path="/biz/service" element={<Navigate to="/service" replace />} />
          <Route path="/biz/service/:tab" element={<Navigate to="/service" replace />} />
          <Route path="/biz/proof" element={<Navigate to="/proof" replace />} />
          <Route path="/biz/proof/:tab" element={<Navigate to="/proof" replace />} />
          <Route path="/biz/inquiry" element={<Navigate to="/inquiry" replace />} />
          <Route path="/job/posts" element={<Navigate to="/recruit" replace />} />
          <Route path="/job/*" element={<Navigate to="/" replace />} />
          <Route path="/notice/*" element={<Navigate to="/recruit" replace />} />

          <Route path="/error" element={<Error404 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
